import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';
import { getStorageQuotaForUser, getStorageLevel, percentage } from 'src/researcher/utils';
import { ONE_MB } from '../constants/common.constants';
import { useApplicationState } from '../context/application';

/**
 * This Hooks Check for current storage allocation quota based on user
 * It returns itf user is premium and storage_allocated_quota
 */
export function useCoWriterStorageAllocation() {
  const premium = useSelector((s: RootState) => s.user.premium || false);
  const TOTAL_STORAGE_ALLOCATED = getStorageQuotaForUser(premium);
  return {
    premium,
    TOTAL_STORAGE_ALLOCATED,
    TOTAL_STORAGE_ALLOCATED_PREMIUM: 100 * ONE_MB,
  };
}

/**
 * Return the storage analysis of currently occupied storage in system
 */
export function useCoWriterUsedStorage() {
  const { TOTAL_STORAGE_ALLOCATED } = useCoWriterStorageAllocation();
  const totalStorageUsed = useApplicationState((state) => state.totalStorageUsed || 0);
  const totalStorageUsedPercent = percentage(totalStorageUsed, TOTAL_STORAGE_ALLOCATED);
  const storageLevel = getStorageLevel(totalStorageUsedPercent);
  return {
    totalStorageUsed,
    totalStorageUsedPercent,
    storageLevel,
  };
}
